import {DomainObject, oneOf} from 'shared/store';
import {observable, action, computed} from 'mobx';
import {t} from 'shared/core';
import {User} from 'main/stores/users';

class ExpensePolicyApprover extends DomainObject {
  @observable id;
  @observable approvalType;
  @observable user;

  @action merge(other) {
    super.merge(other, {
      user: User,
      approvalType: oneOf(['specific_user', 'manager'])
    });
  }

  @computed get value() {
    return this.approvalType === 'manager' ? 'manager' : this.user.id;
  }

  @computed get name() {
    return this.approvalType === 'manager'
      ? t('expenses.manage.policies.edit.Manager')
      : this.user.name;
  }
}

export default ExpensePolicyApprover;
